import { useContext, useRef } from 'react';
import { TableCombinedProps } from './types';
import { getTableColumnProps, getTableRowItems } from './utils';
import { TableStoreContext } from '../../../stores/TableStoreContext';
import { useLocation, useParams } from 'react-router';
import { getQueryParams, noResultsFound } from '../../../lib/utils';
import { DatabasePageParams } from '../../pages/DatabasePage/types';

const usePresenter = (props: TableCombinedProps): TableCombinedProps => {
  const { query } = props;
  const { search } = useLocation();
  const { databaseSlug, tableSlug } = useParams<DatabasePageParams>();
  const queryParams = getQueryParams(search);
  const page = queryParams.page ? Number(queryParams.page) : 1;
  const perPage = queryParams.perPage ? Number(queryParams.perPage) : 100;
  
  const tableStore = useContext(TableStoreContext);
  const { filters } = tableStore.tableConfigurationState?.[tableSlug || ''] || {};

  const tableRef = useRef<HTMLDivElement>(null);
  
  const addEntry = async () => {
    if (tableSlug) {
      await tableStore.addEntry(databaseSlug, tableSlug);
      const newEntryIndex = tableStore.tableState.length - 1;
      tableStore.setSelectedRow(newEntryIndex);
      tableStore.updateRowState('Highlighted', newEntryIndex);
      tableStore.updateCellState('CellFirstSelect', {
        row: newEntryIndex,
        column: 0,
      });
      tableRef?.current?.scrollIntoView(false);
    }
  };
  const filtersApplied = !!(query || (filters && Object.keys(filters).length));

  return {
    ...props,
    noRecordsFound: !noResultsFound(tableStore?.tableState?.length || 0, page, filtersApplied),
    tableColumnTitle: {
      fieldColumnList: {
        fieldColumnItems: getTableColumnProps(tableStore.table),
      },
    },
    tableRowList: {
      tableRowItems: getTableRowItems(
        Number(page || 1),
        Number(perPage || 100),
        tableStore.tableState,
        tableStore.table,
      ),
    },
    button: {
      ...props.button,
      icon: {
        asset: 'AddRoundedFill',
      },
      onClick: addEntry,
    },
    tableRef,
  };
};

export default usePresenter;
